import InformationTable from "components/Shared/InformationTable"
import React, { useEffect, useState } from "react"
import SwitchingBenchmarkRowTable from "./SwitchingBenchmarkRowTable/SwitchingBenchmarkRowTable"
import { useIntl } from "react-intl"
import { BenchmarkDetail } from "../interfaces"
import { useGetSwitchingBenchmarkInformation } from "./useGetSwitchingBenchmarkInformation"
import withVisibility from "components/Shared/Hocs/withVisibility/withVisibility"
import { LEVEL_NAME_DEFAULT } from "components/Transactional/Performance/constants"
import { usePaginationLocal } from "components/Shared/Paginator"
import Paginator from "components/Shared/Paginator/Paginator"
import "./SwitchingBenchmarkTable.scss"
import { generateColumnsHeader, hasValidData } from "./utils"
import { BenchmarkColumns, switchingBenchmarkHeader } from "./constants"
import { SwitchingBenchmarkTableProps } from "./interfaces"
import AsyncMessageResponseHandler from "components/Shared/AsyncMessageResponseHandler/AsyncMessageResponseHandler"
import SkeletonWrapper from "components/Shared/SkeletonWrapper"
import InformationTableSkeleton from "components/Shared/InformationTable/Skeleton/InformationTableSkeleton"

const SwitchingBenchmarkTable: React.FC<SwitchingBenchmarkTableProps> = (
	props
) => {
	const { filtersSwitching, fatherNodeTitle } = props
	const intl = useIntl()
	const [dataTable, setDataTable] = useState<Array<BenchmarkDetail>>([])

	const {
		data = {
			switchingBreakdownMetrics: {
				levelName: LEVEL_NAME_DEFAULT,
				details: [],
			},
		},
		error,
		isError,
		refetch,
		isPendingRequest,
		isIdle,
	} = useGetSwitchingBenchmarkInformation(filtersSwitching)

	useEffect(() => {
		setDataTable(data.switchingBreakdownMetrics.details)
	}, [JSON.stringify(data)])

	const { currentData, getPaginatorProps, setSelectPage } = usePaginationLocal({
		data: dataTable,
		itemsPerPage: 10,
	})

	const handleSortDataTable = (dataTable: any) => {
		setSelectPage(0)
		setDataTable(dataTable)
	}

	const getTitle = () => {
		return intl.formatMessage(
			{ id: "phronesis.breakdown.switching.title" },
			{
				value: intl.formatMessage({
					id: `phronesis.switching.title.next-level.${fatherNodeTitle?.name}`,
				}),
			}
		)
	}

	return (
		<div>
			{!isIdle && (
				<AsyncMessageResponseHandler
					hasData={Boolean(
						hasValidData(data.switchingBreakdownMetrics.details)
					)}
					error={error}
					isError={isError}
					isLoading={Boolean(isPendingRequest)}
					retry={refetch}
				>
					<SkeletonWrapper
						isLoading={Boolean(isPendingRequest)}
						skeleton={<InformationTableSkeleton />}
					>
						<InformationTable
							data={data.switchingBreakdownMetrics.details}
							hasSorting
							titleTable={getTitle()}
							defaultSorting={BenchmarkColumns.DIFFERENCE}
							onSort={handleSortDataTable}
							rowsBody={<SwitchingBenchmarkRowTable data={currentData} />}
							columnsHeader={generateColumnsHeader(
								switchingBenchmarkHeader,
								data.switchingBreakdownMetrics.levelName,
								intl
							)}
							contentFooterTable={
								<>
									<Paginator {...getPaginatorProps()} />
								</>
							}
						/>
					</SkeletonWrapper>
				</AsyncMessageResponseHandler>
			)}
		</div>
	)
}

export default withVisibility(SwitchingBenchmarkTable)
